<template>
  <Row
    type="flex"
    justify="center"
    align="middle"
    style="min-height: 500px; height: 600px;"
  >
    <Col :xs="24" :sm="8" :md="8" :lg="6">
      <Card style="width:360px">
        <div style="text-align:center">
          <Avatar
            icon
            class="ava-large"
            :style="{ background: color, margin: '0 10px 0 0' }"
            >{{ user.name[0] }}</Avatar
          >
          <h2>{{ user.name }}</h2>
          <h3>{{ user.role.name }}</h3>
          <p>Tên đăng nhập: {{ user.email }}</p>
        </div>
        <br />
        <Form
          ref="formCustom"
          :model="formCustom"
          :rules="ruleCustom"
          style="margin: 15px;"
          @submit.native.prevent="handleSubmit('formCustom')"
        >
          <Row type="flex" justify="space-around">
            <Col :xs="24">
              <FormItem :xs="24" prop="oldPassword">
                <Input
                  v-model="formCustom.oldPassword"
                  type="password"
                  placeholder="Mật khẩu hiện tại"
                >
                  <Icon slot="prepend" type="ios-lock-outline"></Icon>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24">
              <FormItem :xs="24" prop="password">
                <Input
                  v-model="formCustom.password"
                  type="password"
                  placeholder="Mật khẩu mới"
                >
                  <Icon slot="prepend" type="ios-lock-outline"></Icon>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24">
              <FormItem :xs="24" prop="passwordConfirmation">
                <Input
                  v-model="formCustom.passwordConfirmation"
                  type="password"
                  placeholder="Xác nhận lại khẩu mới"
                >
                  <Icon slot="prepend" type="ios-lock-outline"></Icon>
                </Input>
              </FormItem>
            </Col>
            <FormItem :xs="12">
              <Button type="primary" html-type="submit">Đổi mật khẩu</Button>
            </FormItem>
            <FormItem :xs="12">
              <Button type="error" to="/logout">Đăng xuất</Button>
            </FormItem>
          </Row>
        </Form>
      </Card>
    </Col>
  </Row>
</template>
<script>
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Hãy nhập mật khẩu mới"));
      } else {
        if (this.formCustom.passwordConfirmation !== "") {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField("passwordConfirmation");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Hãy nhập lại mật khẩu mới một lần nữa"));
      } else if (value !== this.formCustom.password) {
        callback(new Error("Hai mật khẩu không trùng khớp!"));
      } else {
        callback();
      }
    };
    return {
      color: "#f56a00",
      formCustom: {
        oldPassword: "",
        password: "",
        passwordConfirmation: ""
      },
      ruleCustom: {
        oldPassword: [
          {
            required: true,
            message: "Hãy điền mật khẩu hiện tại của bạn",
            trigger: "blur"
          },
          {
            type: "string",
            min: 6,
            message: "Mật khẩu phải dài hơn 6 kí tự",
            trigger: "blur"
          }
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwordConfirmation: [
          { validator: validatePassCheck, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    user() {
      console.log(this.$store.getters["auth/authUser"]);
      return this.$store.getters["auth/authUser"];
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const self = this;
          this.$store
            .dispatch("auth/changepass", {
              oldPassword: this.formCustom.oldPassword,
              password: this.formCustom.password,
              passwordConfirmation: this.formCustom.passwordConfirmation
            })
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                self.$Message.success("Đổi mật khẩu thành công!");
                this.formCustom.oldPassword = "";
                this.formCustom.password = "";
                this.formCustom.passwordConfirmation = "";
              } else {
                self.$Message.error("Đã xảy ra lỗi! " + res.message);
              }
            })
            .catch(() => {
              self.$Message.error("Mật khẩu hiện tại không đúng!");
            });
        } else {
          this.$Message.error("Form không hợp lệ!");
        }
      });
    }
  }
};
</script>

<style>
.ava-large {
  height: 200px;
  width: 200px;
  font-size: 200px;
}
.ava-large > * {
  line-height: 200px !important;
  font-size: 200px;
}
</style>
